import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectProjeMuellifi, updateBaslikDefaults } from '../../../../redux/baslikSlice';

export default function ProjeMuellifiSection() {
  const dispatch = useDispatch();
  const data = useSelector(selectProjeMuellifi);

  const handleChange = (field, value) => {
    dispatch(updateBaslikDefaults({ section: 'projeMuellifi', changes: { [field]: value } }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-field">
        <label>Proje Muellifi</label>
        <input type="text" value={data.projeMuellifi} onChange={e => handleChange('projeMuellifi', e.target.value)} />
      </div>
      <div className="detail-field">
        <label>Onay Yapacak Kurum</label>
        <input type="text" value={data.onayKurum} onChange={e => handleChange('onayKurum', e.target.value)} />
      </div>
      <div className="detail-field">
        <label>Belediye</label>
        <input type="text" value={data.belediye} onChange={e => handleChange('belediye', e.target.value)} />
      </div>
      <div className="detail-field">
        <label>Yapi Denetim Sirketi</label>
        <input type="text" value={data.yapiDenetim} onChange={e => handleChange('yapiDenetim', e.target.value)} />
      </div>
    </div>
  );
}
